import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const VisionMissionScreen = () => {
  const visionRef = useRef(null);
  const missionRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      visionRef.current,
      { opacity: 0, x: -100 },
      {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: visionRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play reverse play reverse",
        },
      }
    );

    gsap.fromTo(
      missionRef.current,
      { opacity: 0, x: 100 },
      {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: missionRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play reverse play reverse",
        },
      }
    );

    gsap.fromTo(
      imageRef.current,
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1,
        scale: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: imageRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play reverse play reverse",
        },
      }
    );
  }, []);

  return (
      <div className="relative font-Montserrat px-4 sm:px-8 lg:px-10 xl:px-12">
          <img
              src="../images/bg03.png" // replace with your image path
              alt="Decorative Background"
              className="absolute bottom-0 right-0 w-fit md:h-full md:w-auto  opacity-10 pointer-events-none select-none"
          />
          <div className="flex flex-col xl:flex-row mb-6 justify-evenly items-center">
              <div className="w-full xl:w-1/2 flex justify-center items-center">
                  <img
                      ref={imageRef}
                      src="../images/man-near-solar-panel.jpg"
                      alt="Man With Solar Panel"
                      className="object-contain w-full max-w-md md:max-w-lg lg:max-w-xl rounded-xl shadow-lg opacity-80 transition-all duration-300 hover:opacity-60 hover:shadow-2xl"
                  />
              </div>
              <div className="w-full xl:w-1/2 flex flex-col gap-2">
                  <div ref={visionRef} className="text-center xl:text-left py-6">
                      <h2 className="text-3xl sm:text-5xl font-extrabold text-[#031c3f]">
                          <span className=" text-5xl sm:text-7xl lg:text-8xl ">“</span>{" "}
                          Vision
                      </h2>
                      <p className="font-roboto mt-4 text-customBlue text-center md:text-left lg:text-left text-sm sm:text-base">
                          To be the leading provider of sustainable solar energy solutions,
                          empowering communities and businesses worldwide with clean,
                          reliable, and affordable energy, while driving the transition to a
                          greener, more sustainable future..
                      </p>
                  </div>
                  <div ref={missionRef} className="text-center xl:text-right py-6">
                      <h2 className="text-3xl sm:text-5xl font-extrabold text-[#031c3f]">
                          Mission{" "}
                          <span className="text-5xl sm:text-7xl lg:text-8xl ">”</span>
                      </h2>
                      <p className="font-roboto text-center md:text-left lg:text-left mt-4 text-customBlue text-sm sm:text-base ">
                          At Sun Pledge Holdings, our mission is to revolutionize the energy
                          landscape by providing innovative and sustainable solar solutions
                          that empower individuals, businesses, and communities to embrace
                          clean energy, reduce their carbon footprint, and create a
                          brighter, greener future for generations to come.
                      </p>
                  </div>
              </div>
          </div>
      </div>
  );
};

export default VisionMissionScreen;
